import type { SettingsRoutes } from './settings-routes';
import { useMatch } from '@tanstack/react-location';
import { PathSegments } from './types';
import { SettingsSearchParams } from './settings-search-param-types';

type ParamsUnion<Union extends string, Item extends string = Union> = Item extends Item ? PathSegments<Item> : never;

type AllRouteParamsUnion = ParamsUnion<SettingsRoutes>;

type AllRouteParams = {
  [Key in AllRouteParamsUnion]: string;
};

export const useSettingsMatchParams = (): AllRouteParams => {
  const { params } = useMatch();

  return params as AllRouteParams;
};

export const useSettingMatchSearch = <Route extends SettingsRoutes>(): SettingsSearchParams<Route> => {
  const { search } = useMatch();

  return search as SettingsSearchParams<Route>;
};
